import { render } from "./WebDevelopmentA.vue?vue&type=template&id=09d42550&scoped=true"
import script from "./WebDevelopmentA.vue?vue&type=script&lang=js"
export * from "./WebDevelopmentA.vue?vue&type=script&lang=js"

import "./WebDevelopmentA.vue?vue&type=style&index=0&id=09d42550&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09d42550"]])

export default __exports__